export var REQUIRED_FIELDS = 'Name and Start are required fields';
export var NEWRELIC_ERROR = 'Error sending metrics to New Relic';
export var NEWRELIC_UNAVAILABLE = 'New Relic is not present on the window object'; // Generic Messages

export var MESSAGES = {
  JS_ERROR: 'jsError'
};
//# sourceMappingURL=constants.js.map